'use strict';
declare var __Client__: string;
declare var __GroupName__: string;
declare var __App__: string;

declare var $: any;

import * as React from 'react';
import { AnnouncementRequest } from "./AnnouncementModels";
const { createContext, useContext } = React;

let announcementsServiceUrl: string;

function GetAnnouncementRequest() {
    const announcementRequest = new AnnouncementRequest();
    announcementRequest.ClientName = __Client__;
    announcementRequest.GroupName = __GroupName__;
    announcementRequest.App = __App__;

    return announcementRequest;
}

const getAnnouncements = () => {
    return new Promise(function (resolve, reject) {
        const ajaxArgs = {
            type: 'POST',
            url: announcementsServiceUrl + 'api/Announcements/',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(GetAnnouncementRequest()),
            dataType: 'json',
            success: function (data: any) {
                resolve(data);
            },
            error: function (err: any) {
                reject(err.responseText);
            }
        };

        $.ajax(ajaxArgs);
    });
};

export const AnnouncementsServiceContext = createContext({
    getAnnouncements: getAnnouncements
});

export const useAnnouncementsService = (serviceUrl: string) => {
    announcementsServiceUrl = serviceUrl;
    return useContext(AnnouncementsServiceContext);
};